import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=b0f1eb80&scoped=true&"
import script from "./Ellipsis.vue?vue&type=script&lang=ts&"
export * from "./Ellipsis.vue?vue&type=script&lang=ts&"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=b0f1eb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f1eb80",
  null
  
)

export default component.exports